<script setup>
import { computed } from "vue";

/* Smooth sparkline with optional area fill + end dot — ported from the
   design's Spark primitive (bt-charts.jsx). */
const props = defineProps({
  data: { type: Array, default: () => [] },
  w: { type: Number, default: 70 },
  h: { type: Number, default: 26 },
  color: { type: String, default: "var(--brand)" },
  fillc: { type: String, default: "" },
  sw: { type: Number, default: 2 },
});

const points = computed(() => {
  const values = props.data.map(Number).filter(Number.isFinite);
  if (values.length < 2) return [];
  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min || 1;
  return values.map((v, i) => [
    (i / (values.length - 1)) * props.w,
    props.h - 3 - ((v - min) / range) * (props.h - 6),
  ]);
});

const line = computed(() => {
  const pts = points.value;
  if (pts.length < 2) return "";
  let d = `M${pts[0][0].toFixed(1)} ${pts[0][1].toFixed(1)}`;
  for (let i = 0; i < pts.length - 1; i++) {
    const p0 = pts[i];
    const p1 = pts[i + 1];
    const cx = (p0[0] + p1[0]) / 2;
    d += ` C${cx.toFixed(1)} ${p0[1].toFixed(1)}, ${cx.toFixed(1)} ${p1[1].toFixed(1)}, ${p1[0].toFixed(1)} ${p1[1].toFixed(1)}`;
  }
  return d;
});

const area = computed(() =>
  line.value ? `${line.value} L${props.w} ${props.h} L0 ${props.h} Z` : "",
);
const last = computed(() => points.value[points.value.length - 1] || null);
</script>

<template>
  <svg :width="w" :height="h" style="display: block; overflow: visible">
    <path v-if="fillc && area" :d="area" :fill="fillc" opacity=".5" />
    <path
      :d="line"
      fill="none"
      :stroke="color"
      :stroke-width="sw"
      stroke-linecap="round"
    />
    <circle v-if="last" :cx="last[0]" :cy="last[1]" r="2.6" :fill="color" />
  </svg>
</template>
